'use strict';
var React = require('react');
var i18n = require('../helper/i18n');

/**
 * 预览选项
 */
var Options = React.createClass({
  propTypes: {
    showComments: React.PropTypes.bool.isRequired,
    alwaysShowLinks: React.PropTypes.bool.isRequired,
    hoverShowLinks: React.PropTypes.bool.isRequired,
    hoverShowRemarks: React.PropTypes.bool.isRequired,
    onShowComments: React.PropTypes.func.isRequired,
    onAlwaysShowLinks: React.PropTypes.func.isRequired,
    onHoverShowLinks: React.PropTypes.func.isRequired,
    onHoverShowRemarks: React.PropTypes.func.isRequired
  },
  render: function () {
    return (
      <div className='preview-options'>
        <div className='option'>
          <div>
            <span onClick={this._onAlwaysShowLinks}>
              <div className='checkbox-control'>
                <input type="checkbox"
                       className='checkbox-control-input'
                       id='link' value="1"
                       checked={this.props.alwaysShowLinks}
                       readOnly
                />
                <label htmlFor='link'></label>
                {i18n.get('ALWAYS_SHOW_LINK')}
              </div>
            </span>
          </div>
          <div>
            <span onClick={this._onHoverShowLinks}>
              <div className='checkbox-control'>
                <input type="checkbox" className='checkbox-control-input' id='hoverlink' value="1" checked={this.props.hoverShowLinks} readOnly/>
                <label htmlFor='hoverlink'></label>
                {i18n.get('HOVER_SHOW_LINK')}
              </div>
            </span>
          </div>
          <div>
            <span onClick={this._onHoverShowRemarks}>
              <div className='checkbox-control'>
                <input type="checkbox" className='checkbox-control-input' id='remarks' value="1" checked={this.props.hoverShowRemarks} readOnly/>
                <label htmlFor='remarks'></label>
                {i18n.get('HOVER_SHOW_REMARK')}
              </div>
            </span>
          </div>
          <div>
            <span onClick={this._onShowComments}>
              <div className='checkbox-control'>
                <input type='checkbox' className='checkbox-control-input' id='comments' value="1" checked={this.props.showComments} readOnly/>
                <label htmlFor='comments'></label>
                {i18n.get('SHOW_REMARKS')}
              </div>
            </span>
          </div>
        </div>
      </div>
    );
  },
  _onShowComments: function (e) {
    this.props.onShowComments(!this.props.showComments);
    e.stopPropagation();
    e.preventDefault();
  },
  _onAlwaysShowLinks: function (e) {
    this.props.onAlwaysShowLinks(!this.props.alwaysShowLinks);
    e.stopPropagation();
    e.preventDefault();
  },
  _onHoverShowLinks: function (e) {
    this.props.onHoverShowLinks(!this.props.hoverShowLinks);
    e.stopPropagation();
    e.preventDefault();
  },
  _onHoverShowRemarks: function (e) {
    this.props.onHoverShowRemarks(!this.props.hoverShowRemarks);
    e.stopPropagation();
    e.preventDefault();
  }
});

module.exports = Options;


/** WEBPACK FOOTER **
 ** ./src/views/Options.jsx
 **/